(function(){
  var root=document.querySelector('.zrv');if(!root||root.__z)return;root.__z=1;
  var wg=root.querySelector('.zrv-wg'),grid=root.querySelector('.zrv-grid'),strip=root.querySelector('.zrv-strip'),more=root.querySelector('.zrv-more'),empty=root.querySelector('.zrv-empty');
  var bPh=root.querySelector('[data-zrv=photos]'),bSort=root.querySelector('[data-zrv=sort]'),bWrite=root.querySelector('[data-zrv=write]');
  var pid=root.getAttribute('data-pid'),cnt=+root.getAttribute('data-count')||0;
  var data=[],seen={},shown=6,onlyPh=false,newest=true,writing=false,page=0,pages=true,busy=false,PER=10;
  function esc(s){var d=document.createElement('div');d.textContent=s==null?'':s;return d.innerHTML;}
  function txt(h){var d=document.createElement('div');d.innerHTML=h||'';[].slice.call(d.querySelectorAll('br,p')).forEach(function(e){e.insertAdjacentText('afterend','\n');});return (d.textContent||'').replace(/\n{3,}/g,'\n\n').trim();}
  function pd(t){return Date.parse(String(t).replace(' UTC','Z').replace(' ','T'))||0;}
  function fmt(t){var m=pd(t);if(!m)return t||'';return new Date(m).toLocaleDateString('en-US',{month:'short',day:'numeric',year:'numeric'});}
  function cut(s){return s.slice(0,220).replace(/\s+\S*$/,'')+'…';}
  /* Legacy: Judge.me widget HTML (.jdgm-rev) */
  function parse(scope){
    var n=0;[].slice.call(scope.querySelectorAll('.jdgm-rev')).forEach(function(r){
      var tx=r.textContent||'';
      var id=r.getAttribute('data-review-id')||('x'+tx.length+tx.slice(0,40));
      if(seen[id])return;seen[id]=1;
      var q=function(s){return r.querySelector(s);};
      var sc=q('.jdgm-rev__rating'),a=q('.jdgm-rev__author'),b=q('.jdgm-rev__body'),t=q('.jdgm-rev__title'),ts=q('.jdgm-rev__timestamp');
      var pics=[].slice.call(r.querySelectorAll('.jdgm-rev__pic-link')).map(function(p){var im=p.querySelector('img');return{full:p.getAttribute('href')||(im&&im.src)||'',src:(im&&(im.getAttribute('src')||im.getAttribute('data-src')))||p.getAttribute('href')||''};}).filter(function(p){return p.src;});
      var raw=ts?(ts.getAttribute('data-content')||ts.textContent):'';
      data.push({a:a?a.textContent.trim():'',s:sc?+(sc.getAttribute('data-score')||5):5,b:b?b.textContent.trim():'',t:t?t.textContent.trim():'',v:!!q('.jdgm-rev__buyer-badge-wrapper')||r.getAttribute('data-verified-buyer')==='true',d:raw,ms:pd(raw),pics:pics});n++;
    });return n;
  }
  /* Current: Judge.me JSON (reviews[]) */
  function parseJson(list){
    var n=0;(list||[]).forEach(function(r){
      var id=r.uuid||('j'+(r.reviewer_name||'')+(r.created_at||''));
      if(seen[id])return;seen[id]=1;
      var pics=(r.pictures_urls||[]).map(function(p){return{full:p.original||p.huge||p.small||'',src:p.compact||p.small||p.original||''};}).filter(function(p){return p.src;});
      var nm=r.is_anonymous_reviewer?'Anonymous':(r.reviewer_name||'');
      data.push({a:nm,s:+r.rating||5,b:txt(r.body_html),t:r.title?txt(r.title):'',v:r.verified_buyer===true,d:r.created_at||'',ms:pd(r.created_at),pics:pics});n++;
    });return n;
  }
  function stars(n){n=Math.max(0,Math.min(5,Math.round(n)));return '★★★★★'.slice(0,n)+'☆☆☆☆☆'.slice(0,5-n);}
  function render(){
    if(!data.length)return;
    empty.hidden=true;
    if(!writing)wg.classList.remove('open');
    var list=data.slice();if(onlyPh)list=list.filter(function(x){return x.pics.length;});
    list.sort(function(x,y){return newest?y.ms-x.ms:x.ms-y.ms;});
    var vis=list.slice(0,shown);
    grid.innerHTML=vis.map(function(x){
      var long=x.b.length>230;
      return '<figure class="zrv-c"><div class="s">'+stars(x.s)+'</div><div class="n">'+esc(x.a)+(x.v?'<span class="v">Verified buyer</span>':'')+'</div>'+(x.t?'<h4>'+esc(x.t)+'</h4>':'')+'<p data-full="'+esc(x.b)+'">'+esc(long?cut(x.b):x.b)+'</p>'+(long?'<button class="m" type="button">More</button>':'')+(x.pics.length?'<div class="ph">'+x.pics.map(function(p){return '<a href="'+esc(p.full)+'" target="_blank" rel="noopener"><img src="'+esc(p.src)+'" alt="" loading="lazy"></a>';}).join('')+'</div>':'')+'<div class="d">'+esc(fmt(x.d))+'</div></figure>';
    }).join('');
    var all=[];data.forEach(function(x){x.pics.forEach(function(p){all.push(p);});});
    if(all.length){strip.hidden=false;strip.innerHTML='<span>Photos from happy customers</span>'+all.slice(0,5).map(function(p){return '<a href="'+esc(p.full)+'" target="_blank" rel="noopener"><img src="'+esc(p.src)+'" alt="" loading="lazy"></a>';}).join('')+(all.length>5?'<i>+'+(all.length-5)+'</i>':'');}
    more.hidden=!(list.length>shown||pages);
  }
  function load(cb){
    if(busy||!pages||!pid){if(cb)cb();return;}
    busy=true;page++;
    var shop=(window.Shopify&&Shopify.shop)||location.hostname;
    var u='https://judge.me/reviews/reviews_for_widget?url='+encodeURIComponent(shop)+'&shop_domain='+encodeURIComponent(shop)+'&platform=shopify&product_id='+pid+'&per_page='+PER+'&page='+page+'&sort_by=created_at&sort_dir=desc';
    fetch(u).then(function(r){return r.json();}).then(function(j){
      var n=0;
      if(j&&Array.isArray(j.reviews)){
        n=parseJson(j.reviews);
        var pg=j.pagination;
        pages=pg?(+pg.current_page<+pg.total_pages):(n>=PER);
      }else{
        var d=document.createElement('div');d.innerHTML=(j&&j.html)||'';
        n=parse(d);if(n<PER||data.length>=cnt)pages=false;
      }
      busy=false;render();if(cb)cb();
    }).catch(function(){busy=false;pages=false;if(cb)cb();});
  }
  grid.addEventListener('click',function(e){var m=e.target.closest('.m');if(!m)return;var p=m.parentNode.querySelector('p');var open=m.textContent==='Less';p.textContent=open?cut(p.getAttribute('data-full')):p.getAttribute('data-full');m.textContent=open?'More':'Less';});
  more.querySelector('button').addEventListener('click',function(){
    shown+=6;
    if(shown>data.length&&pages)load(render);else render();
  });
  bPh.addEventListener('click',function(){onlyPh=!onlyPh;bPh.classList.toggle('on',onlyPh);shown=6;render();});
  bSort.addEventListener('click',function(){newest=!newest;bSort.textContent=newest?'Newest first':'Oldest first';render();});
  bWrite.addEventListener('click',function(){writing=true;wg.classList.add('open');var l=wg.querySelector('.jdgm-write-rev-link');if(l)l.click();wg.scrollIntoView({behavior:'smooth',block:'start'});});
  load();
  var tries=0,iv=setInterval(function(){
    tries++;if(parse(wg))render();
    if(!data.length&&tries===16&&cnt>0)wg.classList.add('open');
    if(tries>90){clearInterval(iv);if(!data.length&&!cnt)empty.hidden=false;}
  },500);
  new MutationObserver(function(){if(parse(wg))render();}).observe(wg,{childList:true,subtree:true});
})();
